import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../../utils/axios";
import EntityManagement from "../../components/formTemplates/EntityManagement";
import EntityTable from "../../components/templateComponents/EntityTable";
import useDropdownFetch from "../../components/apiFetch/useDropdownFetch";
import useDropdownPostFetch from "../../components/apiFetch/useDropdownPostFetch";
import { entitiesConfig } from "../../components/templateComponents/constants";

const SystemUsers = () => {
  const entityConfig = entitiesConfig.systemUsers;

  // Initialize form data
  const [formData, setFormData] = useState(() => {
    const initialData = {};
    entityConfig.formFields.forEach((field) => {
      initialData[field.name] = "";
    });
    return initialData;
  });

  const [errors, setErrors] = useState({});
  const [users, setUsers] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isTableOpen, setIsTableOpen] = useState(false);
  const firstInputRef = useRef(null);
  
  
  const [selectedWorkdays, setSelectedWorkdays] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");

  // Fetch dropdown data
  const merchantOptions = useDropdownPostFetch(
    entityConfig.dropdowns.merchant,
    { view_type: "view" }
  );

  const statusOptions = useDropdownFetch(entityConfig.dropdowns.status);


   // Validation function
  const validateForm = () => {
    const newErrors = {};
    const phoneRegex = /^[6-9]\d{9}$/;

    if (!formData.user_contact || !phoneRegex.test(formData.user_contact)) {
      newErrors.user_contact = "Enter a valid 10-digit mobile number starting with 6–9.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Fetch system users
  const fetchUsers = async () => {
    try {
      const response = await axiosInstance.post(entityConfig.endpoints.fetch, {
        view_type: "view all"
      });
      
      if (response.data.status === "success") {
        setUsers(response.data.message);
      } else {
        throw new Error(response.data.message || "Failed to fetch users");
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Construct the payload based on the edit mode
    const payload = {
      users_id: editMode ? editingId : undefined, 
      user_name: formData.user_name,
      first_name: formData.first_name,
      last_name: formData.last_name,
      user_email: formData.user_email,
      user_password: formData.user_password,
      user_contact: formData.user_contact,
      password_modified_on: new Date().toISOString().split('T')[0] + " 12:00:00",
      workdays: formData.workdays,
      merchant_id: formData.merchant_id || null,
      users_uid: formData.users_uid 
    };

    try {
      if (editMode) {
        await axiosInstance.post(entityConfig.endpoints.update, payload);
      } else {
        await axiosInstance.post(entityConfig.endpoints.create, payload);
      }
      
      fetchUsers();
      resetForm();
      setSuccessMessage("Form submitted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000); 
    } catch (error) {
      console.error("Error saving user:", error);
    }
  };

  const handleEdit = (id) => {
    const userToEdit = users.find(user => user.users_id === id);
    if (userToEdit) {
      setFormData({
        ...userToEdit,
        merchant_id: userToEdit.merchant_id?.toString() || "",
        status_id: userToEdit.status_id?.toString() || "",
       
      });
      setEditingId(id);
      setEditMode(true);
      setIsTableOpen(false);
    }
  };

  const resetForm = () => {
    const clearedForm = {};
    entityConfig.formFields.forEach(field => {
      clearedForm[field.name] = "";
    });
    setFormData(clearedForm);
    setEditMode(false);
    setEditingId(null);
    setSelectedWorkdays([]); 
      setErrors({});
  };

  return (
    <div className="system-users">
      <EntityManagement
        entityName={entityConfig.name}
        formFields={entityConfig.formFields}
        formData={formData}
        setFormData={setFormData}
        handleFormSubmit={handleSubmit}
        dropdownData={{
          merchant: merchantOptions.options || [],
          status: statusOptions.options || []
        }}
        showWorkdays={true}
        selectedWorkdays={selectedWorkdays} 
        setSelectedWorkdays={setSelectedWorkdays} 
        handleViewTableClick={() => setIsTableOpen(true)}
        firstFormFieldRef={firstInputRef}
        successMessage={successMessage}
           errors={errors}
      />

      {isTableOpen && (
        <div className="modal">
          <div className="modal-content">
            <button onClick={() => setIsTableOpen(false)}>Close</button>
            <EntityTable
              data={users}
              columns={entityConfig.columns}
              onEdit={handleEdit}
              keyField="users_id"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SystemUsers;


